import './ProductCover.scss'

class ProductCover {}

export default ProductCover
